module.exports = __webpack_public_path__ + "static/media/04c_casestudy_sanofi_img.5b330878.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/patient-hope/04c_casestudy_sanofi_img.jpg
// module id = 369
// module chunks = 0